/**
 * DEUX FAITS, UN LANGAGE HUMAIN.
 *
 * ╔═══════════════════════════════════════════════════════════════════════╗
 * ║ C'EST DE LA PRESENTATION, PAS UNE TROISIEME VERITE.                   ║
 * ╚═══════════════════════════════════════════════════════════════════════╝
 *
 * L'API rend deux faits : `a_version_active` et `est_arme`. Elle ne rend PAS
 * d'`etat_affiche`, et ne doit pas en rendre -- trois valeurs pour deux faits
 * divergeraient au premier ajustement, et personne ne saurait laquelle croire.
 *
 * L'interface les traduit, sans rien decider :
 *
 *   pas de version active            -> Brouillon    (jamais publiee)
 *   version active, non armee        -> En pause     (prete, n'ecoute pas)
 *   version active, armee            -> En service   (les declencheurs ecoutent)
 *
 * ── LE QUATRIEME CAS EST UNE ANOMALIE, ET SE DIT ────────────────────────
 *
 * `est_arme` vrai sans version active ne devrait jamais exister : l'archivage
 * desarme, et armer suppose quelque chose a servir. Si cela survient, c'est un
 * defaut du moteur. Lui inventer un etat elegant le MAQUILLERAIT, et personne
 * n'irait chercher la cause. On l'affiche comme ce qu'il est.
 */

export type EtatLisible = 'en_service' | 'en_pause' | 'brouillon' | 'incoherent';

export interface FaitsAutomatisation {
  readonly est_arme: boolean;
  readonly a_version_active: boolean;
}

export function etatLisible(a: FaitsAutomatisation): EtatLisible {
  if (!a.a_version_active) return a.est_arme ? 'incoherent' : 'brouillon';
  return a.est_arme ? 'en_service' : 'en_pause';
}

export const LIBELLES_ETAT: Readonly<Record<EtatLisible, string>> = {
  en_service: 'En service',
  en_pause: 'En pause',
  brouillon: 'Brouillon',
  incoherent: 'Configuration incohérente',
};

/** La classe d'etiquette. `incoherent` porte le refus : c'est un defaut. */
export const CLASSES_ETAT: Readonly<Record<EtatLisible, string>> = {
  en_service: 'etiquette etiquette--succes',
  en_pause: 'etiquette etiquette--alerte',
  brouillon: 'etiquette',
  incoherent: 'etiquette etiquette--refus',
};

/** Ce que l'etat signifie, en une phrase, pour qui survole l'etiquette. */
export const EXPLICATIONS_ETAT: Readonly<Record<EtatLisible, string>> = {
  en_service: 'Une version est publiée et les déclencheurs écoutent.',
  en_pause: 'Une version est publiée, mais les déclencheurs sont désarmés.',
  brouillon: 'Aucune version n’a encore été publiée.',
  incoherent: 'Armée sans version active : signalez cette automatisation.',
};
